/**
 * Opt-in diagnostic logging. Defaults OFF even in dev — same contract as
 * `configureAtomDevtools`'s `isDev` option, which also defaults false, so a dev
 * build is quiet unless someone asks for the noise.
 *
 * Enable with `VITE_LA_DEBUG_LOGS=true` in the renderer's environment.
 *
 * NOT for failures: `console.error`/`console.warn` stay ungated so a real
 * problem is never hidden behind a flag (`.claude/rules/no-fallbacks.md`).
 */
const enabled =
  typeof import.meta !== 'undefined' &&
  (import.meta as { env?: Record<string, string | undefined> }).env
    ?.VITE_LA_DEBUG_LOGS === 'true';

export function debugLog(scope: string, ...args: unknown[]): void {
  if (!enabled) return;
  console.debug(`[${scope}]`, ...args);
}

export const debugLogEnabled = enabled;
